/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import { ExpandMoreIcon } from "@dotnet/telematics-design-system";

import { useStyles } from "./styles";

interface NotesAccordionProps {
  expandedPanel: string;
  index: number;
  isLast: boolean;
  rootPadding: string;
  onCollapse: (value: string, expanded: boolean) => void;
  title: ReactNode;
  details: ReactNode;
  showAll: boolean;
  detailsPadding?: string;
}

const NotesAccordion = ({
  index,
  expandedPanel,
  isLast,
  rootPadding,
  onCollapse,
  title,
  details,
  showAll = true,
  detailsPadding
}: NotesAccordionProps) => {
  const isExpanded = expandedPanel === `panel${index}`;

  const { mainAccordionCSS, releaseNotesCSS, headerMainCSS } = useStyles({
    isExpanded,
    isLast,
    rootPadding,
    detailsPadding
  });

  const showOnlyFirstNote = !showAll && index !== 0;

  return (
    <Accordion
      elevation={0}
      data-testid="notes-accordion"
      expanded={isExpanded}
      onChange={(_, expanded) => onCollapse(`panel${index}`, expanded)}
      disableGutters
      css={css([
        mainAccordionCSS,
        { display: showOnlyFirstNote ? "none" : "block" }
      ])}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        id="accordionHeader"
        key={index}
      >
        <div css={css(headerMainCSS)}>{title}</div>
      </AccordionSummary>
      <AccordionDetails css={css(releaseNotesCSS)}>{details}</AccordionDetails>
    </Accordion>
  );
};

export default NotesAccordion;
